export const THIRD_PARTY_SERVICE_TYPE = {
  DELIVERY: 0,
  FRAUD_PROTECTION: 1,
  EBT_AUTHORIZATION: 2,
  GENERIC: 3,
  SHIPPING: 4,
};

export const THIRD_PARTY_SERVICE_PROVIDER = {
  DOORDASH: { id: 1, serviceType: THIRD_PARTY_SERVICE_TYPE.DELIVERY },
  SIGNIFYD: { id: 2, serviceType: THIRD_PARTY_SERVICE_TYPE.FRAUD_PROTECTION },
  CARDKNOX_EBT: {
    id: 3,
    serviceType: THIRD_PARTY_SERVICE_TYPE.EBT_AUTHORIZATION,
  },
  TWILIO: { id: 4, serviceType: THIRD_PARTY_SERVICE_TYPE.GENERIC },
  RED_PEPPER: { id: 5, serviceType: THIRD_PARTY_SERVICE_TYPE.GENERIC },
  SHIP_STATION: { id: 6, serviceType: THIRD_PARTY_SERVICE_TYPE.SHIPPING },
  INCOMM_OTC: { id: 30, serviceType: THIRD_PARTY_SERVICE_TYPE.GENERIC },
};
